/**
 * Compares two arrays by their item IDs to check if they're identical
 * (same items in the same order)
 * 
 * @param arr1 First array to compare
 * @param arr2 Second array to compare
 * @param getItemId Function to extract unique ID from each item
 * @returns true if arrays have identical items in identical order, false otherwise
 */
export function areArraysIdenticalByIds<T>(
  arr1: T[] | undefined,
  arr2: T[] | undefined,
  getItemId: (item: T) => string
): boolean {
  // Handle undefined/empty arrays
  if (!arr1 && !arr2) return true
  if (!arr1 || !arr2) return false
  
  // Different lengths means different arrays
  if (arr1.length !== arr2.length) return false
  
  // Empty arrays are identical
  if (arr1.length === 0) return true
  
  // Compare item IDs in order
  return arr1.every((item, index) => 
    getItemId(item) === getItemId(arr2[index])
  )
}

